var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.523,
    height: 17.72,
    viewBox: "0 0 17.523 17.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-edit",
    d: "M13.251,2.059,7.272,8.038a23.212,23.212,0,0,0-5.539,8.908.892.892,0,0,0,.216.924l0,0a.892.892,0,0,0,.632.264.9.9,0,0,0,.291-.049,23.211,23.211,0,0,0,8.908-5.539l5.979-5.978a3.191,3.191,0,0,0-4.512-4.512Zm-2.28,9.678a22.068,22.068,0,0,1-7.977,5.091A22.067,22.067,0,0,1,8.085,8.851l3.561-3.561,2.886,2.886ZM16.95,5.759l-1.6,1.6L12.459,4.477l1.6-1.6A2.041,2.041,0,1,1,16.95,5.759Z",
    transform: "translate(-1.424 -0.666)",
    fill: "#f39628",
    stroke: "#f39628",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.79cb29739350fe2a25294dbed9db8db4.svg";
export { ForwardRef as ReactComponent };